import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
//import images
import { layoutModeTypes } from "../../Components/constants/layout";
import logoDark from '../../assets/images/exiaLogo_dark.png';
import logoLight from '../../assets/images/exiaLogo_light.png';
import { useSelector } from "react-redux";
import { createSelector } from 'reselect';

const BasicLogout = () => {
  // Get the current layout mode from Redux store
  const selectLayoutState = (state) => state.Layout;
  const layoutData = createSelector(
    selectLayoutState,
    (layout) => ({
      layoutModeType: layout.layoutModeType,
    })
  );
  const { layoutModeType } = useSelector(layoutData);
  
  // Use the actual layout mode from Redux instead of hardcoded logic
  const mode = layoutModeType || layoutModeTypes.LIGHTMODE;
  
  document.title="Log Out | SeedNations";
  return (
    <React.Fragment>
      <div className="auth-page-content">
        <div className="auth-page-wrapper">
          <ParticlesAuth>
            <div className="auth-page-content">
              <Container>
                <Row>
                  <Col lg={12}>
                    <div className="text-center mt-sm-5 mb-4 text-white-50">
                      <div>
                        <Link to="/dashboard" className="d-inline-block auth-logo">
                          {/* Logo logic: Light mode shows light logo, Dark mode shows dark logo */}
                          <img src={mode === layoutModeTypes.LIGHTMODE ? logoLight : logoDark} alt="" height="200" />
                        </Link>
                      </div> 
                    </div>
                  </Col>
                </Row>

                <Row className="justify-content-center">
                  <Col md={8} lg={6} xl={5}>
                    <div className="mt-4">
                      <div className="p-4 text-center">
                        <lord-icon
                          src="https://cdn.lordicon.com/hzomhqxz.json"
                          trigger="loop"
                          colors="primary:#25a0e2,secondary:#00bd9d"
                          style={{ width: "180px", height: "180px" }}>
                        </lord-icon>

                        <div className="mt-4 pt-2">
                          <h5>You are Logged Out</h5>
                          <p className="text-muted">Thank you for using <span className="fw-semibold">Seed Nations</span> admin template</p>
                          <div className="mt-4">
                            <Link to="/login" className="btn  w-100" style={{backgroundColor:'#24F4C0',color:'#000'}}>Sign In</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </ParticlesAuth>

        </div>
      </div >
    </React.Fragment >
  );
};

export default BasicLogout;